import gql from "graphql-tag";
import { Company } from "../baseTypes";
export default gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      id
      name
      settings {
        hasSelfTests
        defaultSelfTests
      }
    }
  }
`;
export interface CreateCompanyMutation {
  createCompany: Company | null;
}
